require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./laboratoire-de-communications-audiovisuelles-0-1-2.json") })
        }
      }, "path---laboratoire-de-communications-audiovisuelles-0-1-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---laboratoire-de-communications-audiovisuelles-0-1-2!./.cache/json/laboratoire-de-communications-audiovisuelles-0-1-2.json
// module id = 472
// module chunks = 231608221292675